export const experiences = [
  {
    id: 'restoo',
    company: 'Restoo',
    web: 'restoo.me',
    url: 'https://www.restoo.me/',
  },
  {
    id: 'grability',
    company: 'Grability',
    web: 'grability.com',
    url: 'https://www.grability.com/',
  },
  {
    id: 'gestinet',
    company: 'Gestinet',
    web: 'gestinet.com',
    url: 'https://www.gestinet.com/',
  },
  {
    id: 'clicko',
    company: 'Clicko',
    web: 'clicko.es',
    url: 'https://clicko.es/',
  },
  {
    id: 'binary_sunset',
    company: 'Binary Sunset',
    web: 'soundcloud.com/binary-sunset',
    url: 'https://soundcloud.com/binary-sunset-213234190',
  },
];
